module.exports = __webpack_public_path__ + "img/ico-send.34af4334.svg";